// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Import wallet service
import WalletServices from '@services/Mywallet'

export const fetchWallet = createAsyncThunk('wallet/fetchWallet', async () => {
try {
  // Use the centralized service function
  const data = await WalletServices.fetchWalletList();
  return { data };
} catch (err) {
  console.error("Error fetching wallet data:", err);
  return { data: [] };
}
})

export const layoutSlice = createSlice({
  name: 'wallet',
  initialState: {
    walletList: [],
    isLoading: false
  },
  reducers: {
    handleSearchQuery: (state, action) => {
      state.query = action.payload
    },
    handleStartLoading: (state, action) => {
      state.isLoading = true
    }
  },
  extraReducers: builder => {
    builder
      .addCase(fetchWallet.fulfilled, (state, action) => {
        state.isLoading = false
        state.walletList = action.payload.data
      })
  }
})

export const { handleSearchQuery, handleStartLoading } = layoutSlice.actions

export default layoutSlice.reducer
